module.exports = __webpack_public_path__ + "img/product5.39bce23b.png";